import { showToast } from '@Sage/hoi-poi-ui';

const defaultCrudToastProps = {
    position: 'bottomLeft',
    transition: 'slide',
    useDefaultCloseButton: true,
};

export const successToast = ({ t, ...props }) => {
    if (!t && !props.title) return;
    showToast({
        ...defaultCrudToastProps,
        type: 'success',
        title: t('cfm_label_success'),
        ...props,
    });
};

export const errorToast = ({ t, ...props }) => {
    if (!t && !props.title) return;
    showToast({
        ...defaultCrudToastProps,
        type: 'error',
        title: t('error_generalerror'),
        ...props,
    });
};

export const infoToast = ({ t, ...props }) => {
    if (!t) return;
    showToast({
        ...defaultCrudToastProps,
        type: 'info',
        ...props,
    });
};
